module.exports = __webpack_public_path__ + "img/box3_bg.560536c3.png";